import type { LotEvent } from '../types/lot'

// Findings #201: Base de datos hides the rows of a lot that left the unit, as
// it does for deleted lots (#200). A lot leaves a unit in two ways:
// - the whole lot moves (Trasladar lote to a unit without that lot): the lot
//   record now sits in another unit, so its old rows here are "foreign";
// - its fish join the same lot in another unit (Trasladar lote to a unit that
//   already has it): the lot stays here, Inactivo, with a 0 count, and its
//   last fish move points at the destination.
// A partial move leaves the lot Activo here, so its rows stay visible.

type LotLike = { id: string; stage?: string }

const record = (value: unknown): Record<string, unknown> | undefined => (
  value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : undefined
)

/**
 * For each Inactivo lot whose last fish move took its fish out to another unit:
 * lotId → the destination unit id.
 */
export const findJoinedOutDestinations = (
  lots: ReadonlyArray<LotLike>,
  events: ReadonlyArray<LotEvent>
): Map<string, string> => {
  const inactiveIds = new Set(lots.filter((lot) => lot.stage === 'Inactive').map((lot) => String(lot.id)))
  const latest = new Map<string, { at: number; toUnitId: string | null }>()
  for (const event of events) {
    const fishMove = record(record(event.metadata)?.fishMove)
    if (!fishMove) continue
    const lotId = String(fishMove.sourceLotId ?? '')
    if (fishMove.direction !== 'out' || !inactiveIds.has(lotId)) continue
    const at = Date.parse(event.recordedAt)
    const previous = latest.get(lotId)
    if (previous && previous.at > at) continue
    const toUnitId = typeof fishMove.toProductionUnitId === 'string' && fishMove.toProductionUnitId.trim()
      ? fishMove.toProductionUnitId.trim()
      : null
    latest.set(lotId, { at, toUnitId })
  }
  const out = new Map<string, string>()
  latest.forEach((value, lotId) => {
    if (value.toUnitId) out.set(lotId, value.toUnitId)
  })
  return out
}
